export default "__VITE_ASSET__7gUp5LIG__"